// extracted by mini-css-extract-plugin
module.exports = {"user":"User_user__OxikF","cart-icon":"User_cart-icon__3wEgI","avatar":"User_avatar__1R8tb"};